import { StyledProps, ThemedProps, React, withStyles, classNames } from '@api';
import { IconButton, Tooltip } from '@material-ui/core'
import { FirstPage as FirstPageIcon, KeyboardArrowLeft, KeyboardArrowRight, LastPage as LastPageIcon } from '@material-ui/icons'
import {globalStores} from '@stores'
import * as css from './LibraryTableFooter.css'
import { Tooltip2 } from '@api';
;

const styles = theme => ({
  root: {
    flexShrink: 0,
    color:      theme.palette.text.secondary,
    marginLeft: theme.spacing() * 2.5
  }
})

interface MyProps extends StyledProps, ThemedProps {
  count: number,
  onChangePage: (e, page) => void
  page: number,
  rowsPerPage: number
}

@(withStyles as any)(styles, {withTheme: true})
export class LibraryTableFooter extends React.Component <MyProps> {
  static defaultProps = {}

  render() {
    const {
            classes, count, page, rowsPerPage, theme, onChangePage
          } = this.props,
      {strings} = globalStores

          
    return (
      <div className={classNames(css.root, classes.root)}>
        <Tooltip2 content={`${strings.first} ${strings.page}`}>
          <div className={css.buttonWrapper}>
            <IconButton
              onClick={(event) => onChangePage(event, 0)}
              disabled={page === 0}
              aria-label='First Page'
            >
              {theme.direction === 'rtl' ? <LastPageIcon className={css.darkIcon}/> : <FirstPageIcon className={css.darkIcon}/>}
            </IconButton>
          </div>
        </Tooltip2>

        <Tooltip2 content={`${strings.previous} ${strings.page}`}>
          <div className={css.buttonWrapper}>
            <IconButton
              onClick={(event) => onChangePage(event, page - 1)}
              disabled={page === 0}
              aria-label='Previous Page'
            >
              {theme.direction === 'rtl' ? <KeyboardArrowRight className={css.darkIcon}/> : <KeyboardArrowLeft className={css.darkIcon}/>}
            </IconButton>
          </div>
        </Tooltip2>

        <Tooltip2 content={`${strings.next} ${strings.page}`}>
          <div className={css.buttonWrapper}>
            <IconButton
              onClick={(event) => onChangePage(event, page + 1)}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label='Next Page'
            >
              {theme.direction === 'rtl' ? <KeyboardArrowLeft className={css.darkIcon}/> : <KeyboardArrowRight className={css.darkIcon}/>}
            </IconButton>
          </div>
        </Tooltip2>

        <Tooltip2 content={`${strings.last} ${strings.page}`}>
          <div className={css.buttonWrapper}>
            <IconButton
              onClick={(event) => onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label='Last Page'
            >
              {theme.direction === 'rtl' ? <FirstPageIcon className={css.darkIcon}/> : <LastPageIcon className={css.darkIcon}/>}
            </IconButton>
          </div>
        </Tooltip2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/libraries/components/LibraryTableFooter.tsx